export const enum StaticVariables {
    
}

export const germanLat = 54.685005;
export const germanLng = 9.278153;

export const germanRegionNos = [23055,23099];

export const germanRegionID = "DF9BAAAC-6EC0-4F61-B3A7-DB83942EE5A6";